import { useCallback, useEffect } from 'react';
export function useTrapFocus(_ref) {
  let {
    active,
    container
  } = _ref;
  const listener = useCallback(evt => trapFocus(container)(evt), [container]);
  useEffect(() => {
    if (active) {
      document.addEventListener('keydown', listener);
    } else {
      document.removeEventListener('keydown', listener);
    }
  }, [active, listener]);
}
const trapFocus = container => event => {
  if (!container.current) {
    return;
  }
  const focusableElements = keyboardFocusableChildren(container.current);
  if (focusableElements.length < 1) {
    if (event.key === 'Tab') {
      event.preventDefault();
    }
    return;
  }
  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];
  if (event.key === 'Tab') {
    const isBackTab = event.shiftKey;
    if (isBackTab && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!isBackTab && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
};
function keyboardFocusableChildren(element) {
  return [...element.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')].filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}
//# sourceMappingURL=use-trap-focus.js.map